import Button from '../../../components/CustomButtons/ButtonTS';
import FastForwardOutlined from '@material-ui/icons/FastForwardOutlined';
import React, { useState } from 'react';
import { INode, ISystem } from '../../helpers/interfaces';
import Loading from '../Loading/Loading';
import Tooltip from "@material-ui/core/Tooltip";

interface IAccelerateIconProps {
	show: boolean;
	node: INode;
	accelerateNode: (nodeID: number, updatedViaWebsiteAt: string, acceleratedUntil: string) => void;
	showAccelerateCard(node: INode): void;
}

export const AccelerateIcon = (props: IAccelerateIconProps) => {
	const { show, node, showAccelerateCard } = props;

	if (!show) {
		return null;
	}
	const buttonStyle = {
		backgroundColor: 'transparent',
		outline: 'none'
	};
	const buttonActiveStyle = {
		backgroundColor: 'rgba(0, 150, 255, 0.1)',
		borderRadius: '50%',
		boxShadow: 'rgba(78, 133, 176, 0.08) 0px 0px 15px, rgba(146, 184, 210, 0.4) 0px 0px 30px'
	};

	return (
        <Tooltip title="Accelerate">
            <div>
                <Button
                    color={'info'}
                    simple
                    justIcon
					style={Date.parse(node.AcceleratedUntil) > Date.now() ? buttonActiveStyle : buttonStyle}
                    // onClick={() => {
					// 	accelerateNode(node.id, node.updatedViaWebsiteAt, node.AcceleratedUntil);
					// }}
					onClick={() => showAccelerateCard(node)}
                    data-testid='accelerateIcon'
                >
                    <FastForwardOutlined />
                </Button>
            </div>
        </Tooltip>
	);
};

export default AccelerateIcon;
